import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useStateValue } from "../../StateProvider";
import { getDefaultValue } from "../../utils";
import UserProfileAvatarWidget from "./UserProfileAvatarWidget";

/** Same destinations as `DashboardAside` primary items (icons only in header). */
const HEADER_QUICK_NAV = [
  { to: "/dashboard", exact: true, labelKey: "Dashboard", icon: "fa-home" },
  { to: "/profile", labelKey: "Manage Profile", icon: "fa-user-edit" },
  { to: "/contests", labelKey: "Contests", icon: "fa-trophy" },
  {
    to: "/support",
    labelKey: "Support",
    icon: "fa-question-circle",
    isActive: (match, location) =>
      !!match || location.pathname.startsWith("/support"),
  },
];

/**
 * Compact avatar + display name for the participant dashboard page header.
 */
export default function DashboardHeaderProfileWidget({
  profile,
  onProfileUpdated,
  showManageProfile = true,
  navItems,
}) {
  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    const t = translations.find((x) => x.key === str);
    if (t) return getDefaultValue(t);
    return "#" + str;
  };

  if (!profile) {
    return null;
  }

  const displayName = `${(profile.first_name || "").trim()} ${(
    profile.last_name || ""
  ).trim()}`.trim();

  return (
    <div className="participant-dashboard-header-profile">
      <UserProfileAvatarWidget
        variant="header"
        profile={profile}
        onProfileUpdated={onProfileUpdated}
        showChangePhoto={profile.role !== "referee"}
      />
      <div className="participant-dashboard-header-profile__meta lan-text-right">
        {displayName ? (
          <Link
            to="/profile"
            className="participant-dashboard-header-profile__name-link"
          >
            <span className="participant-dashboard-header-profile__name font-weight-bold text-4">
              {displayName}
            </span>
          </Link>
        ) : null}

        {showManageProfile ? (
          <nav
            className="participant-dashboard-header-profile__quick-nav"
            aria-label="Navigation"
          >
            {(navItems || HEADER_QUICK_NAV).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                exact={item.exact}
                isActive={item.isActive}
                className="participant-dashboard-header-profile__quick-nav-link"
                activeClassName="participant-dashboard-header-profile__quick-nav-link--active"
                aria-label={translate(item.labelKey)}
                title={translate(item.labelKey)}
              >
                <i className={`fas ${item.icon}`} aria-hidden />
              </NavLink>
            ))}
          </nav>
        ) : null}
      </div>
    </div>
  );
}
